import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 8,
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 2000,
    width: "70vw", // 70% of viewport width
    height: "32vh", // Same as width = square
    maxWidth: 300, // Limit size on desktop
    maxHeight: 300, // Keep it square

    boxShadow: theme.shadows[6],
    padding: 0,
    margin: 0,

    "& .MuiAlert-message": {
      padding: `0 !important`,
      margin: `0 !important`,
    },

    [theme.breakpoints.down("xs")]: {
      width: "90vw",
      height: "70vw",
      maxWidth: "none",
      maxHeight: "none",
    },
  },
  titleCenter: {
    justifyContent: "center",
    textAlign: "center",
  },

  titleLeft: {
    justifyContent: "flex-start",
    textAlign: "left",
  },
  noIcon: {
    "& .MuiAlert-icon": {
      display: "none",
    },
  },
  splRoot: {
    borderRadius: 0,
    position: "absolute",
    width: "100%",
    top: "70px",
    left: 0,
    zIndex: 10,
  },
  backgroundWarning: {
    backgroundColor: "#fff7c9",
    color: "#000", // Ensure readable text
  },

  backgroundError: {
    backgroundColor: "#f04545",
    color: "#fff",
  },
  messageContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: 0, // ✅ remove internal spacing
    margin: 0,
  },
  alertMsgDiv: {
    padding: "15px",
    margin: 0,
    width: "100%",
    height: "200px",
    backgroundColor: "inherit",

    [theme.breakpoints.down("xs")]: {
      fontSize: "19px",
    },
  },
  iconWithTitle: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    marginBottom: "10px",
    color: "white",
    fontWeight: 700,
    fontSize: "16px",
  },

  icon: {
    fontSize: "20px",
    color: "black",
  },
  alertDiv: {
    margin: 0,
    paddingLeft: "18px !important",
    paddingTop: "15px !important",
    display: "flex",
    padding: 0,
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
    flexDirection: "column",
    backgroundColor: "#ffa006",
  },
  alertErrDiv: {
    margin: 0,
    paddingLeft: "15px !important",
    paddingTop: "15px !important",
    display: "flex",
    padding: 0,
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
    flexDirection: "column",
    backgroundColor: "#f01616",
  },
  actionButtonContainer: {
    // marginTop: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "10px",
  },
  actionButton: {
    backgroundColor: "#ff9800",
    border: "2px solid #ffffff",
    boxShadow: "none",
    textTransform: "none",
    "&:hover, &:focus": {
      backgroundColor: "#f57c00",
    },
  },
  errorActionButton: {
    backgroundColor: "#f44336",
    border: "1px solid #ffffff",
    boxShadow: "none",
    textTransform: "none",
    "&:hover, &:focus": {
      backgroundColor: "#d32f2f",
    },
  },
  okButton: {
    color: "#fff",
    height: "7vh",
    textTransform: "none",
    width: "86%", // default for mobile

    // [theme.breakpoints.up("sm")]: {
    //   width: "50%", // for screen ≥600px
    // },

    "&:hover": {
      backgroundColor: "#3a3535",
    },
  },
}));

export default useStyles;
